document.addEventListener('click', function(e) {
  'use strict';
  const link = e.target.closest('[data-beneficial-ownership-view]');
  if (!link || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

  e.preventDefault();

  fetch(link.href)
    .then(function(response) {
      if (!response.ok) throw new Error(response.statusText);
      return response.text();
    })
    .then(function(html) {
      const section = new DOMParser().parseFromString(html, 'text/html').getElementById('beneficial-owners');
      if (!section) throw new Error('missing #beneficial-owners');

      document.getElementById('beneficial-owners').replaceWith(section);
      history.replaceState(null, '', link.href);
    })
    .catch(function() {
      window.location.href = link.href;
    });
});
